import {
  AfterContentChecked,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {IQuestionComponent} from "../../../../../../interfaces/IQuestionComponent";
import {EMPTY, of, Subject, switchMap} from "rxjs";
import {SurveyViewerService} from "../../../services/survey-viewer.service";
import {OpenStatementErrorMatcher} from "../../../../../../error-matchers/OpenStatementErrorMatcher";
import {ImageUpload} from "../../../../../../models/questions/ImageUpload";
import {AbstractControl} from '@angular/forms';
import {ImageUploadService} from "@store/file-upload/image-upload.service";
import {BehaviorSubject, Observable} from "rxjs";

@Component({
  selector: 'app-file-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent implements IQuestionComponent, OnDestroy, AfterViewChecked {

  @ViewChild('uploadArea') uploadArea: any;
  private ngUnsubscribe = new Subject<void>();
  @Input() isSmallScreen: boolean

  @Input() question: ImageUpload;
  @Input() activeLang: string
  errorMatcher: OpenStatementErrorMatcher;

  imgUploader: any;
  test: any = 0;
  private _uploadedImgUrl$: Observable<string | null> | null = null;

  constructor(
    public surveyViewerService: SurveyViewerService,
    public imageUploadService: ImageUploadService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  questionFormControl: AbstractControl<any, any>;

  get dragAndDropAreaId() {
    return `drag-drop-area-${this.isSmallScreen ? 'small-' : ''}${this.question.key}`;
  }

  get uploadedImgUrl$(): Observable<string | null> {
    if (!this._uploadedImgUrl$ && this.question) {
      if (!this.imageUploadService.uploadedImgUrl$[this.question.key]) {
        this.imageUploadService.uploadedImgUrl$[this.question.key] = new BehaviorSubject(null);
      }
      this._uploadedImgUrl$ = this.imageUploadService.uploadedImgUrl$[this.question.key].asObservable();
    }
    return this._uploadedImgUrl$ || new BehaviorSubject<string | null>(null).asObservable();
  }

  setupUploader() {
    this.imgUploader = this.imageUploadService.createUploader(
      this.surveyViewerService.activeSurvey$.value.id, this.question.key, this.isSmallScreen);
    this.imgUploader.getPlugin('Dashboard');
  }

  deleteUpload() {
    document.getElementById(this.dragAndDropAreaId).style.display = 'block';

    this.imageUploadService.deleteUpload(this.question.key);
    this.questionFormControl.get(this.question.rowsOrder[0]).get(this.question.imageControlName)
      .get(this.question.statementsOrder[0]).setValue('');

    setTimeout(() => {
      let done = false;
      const el = document.getElementsByClassName('uppy-u-reset');
      for(let i = 0;
          i < el.length || done ;
          i++){
        if (!el.item(i).classList.contains('uppy-DashboardTab-btn')){
          (el.item(i) as HTMLButtonElement).click();
          done = true;
        }
      }
    }, 500);

  }

  ngAfterViewChecked() {
    if (this.test === 1){
      this.test += 1;
      this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form.get(this.question.key);
      this.setupUploader();
      
      // S'assurer que l'Observable est initialisé (via le getter)
      const _ = this.uploadedImgUrl$;
      
      // Vérifier si une image est déjà chargée
      const currentValue = this.imageUploadService.uploadedImgUrl$[this.question.key].value;
      if (currentValue) {
        const element = document.getElementById(this.dragAndDropAreaId);
        if (element) {
          element.style.display = 'none';
        }
        this.cdr.detectChanges();
      }
      
      this.imageUploadService.uploadedImgUrl$[this.question.key]
        .pipe(switchMap((d) => d ? of(d) : EMPTY))
        .subscribe((url) => {
          const element = document.getElementById(this.dragAndDropAreaId);
          if (element) {
            element.style.display = 'none';
          }
          this.questionFormControl.get(this.question.rowsOrder[0]).get(this.question.imageControlName)
            .get(this.question.statementsOrder[0]).setValue(url);
          this.cdr.detectChanges();
        });
    }else {
      this.test += 1;
    }

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
